export var MediaTrackType;
(function (MediaTrackType) {
    MediaTrackType["audio"] = "audio";
    MediaTrackType["video"] = "video";
    MediaTrackType["screen"] = "screen";
})(MediaTrackType || (MediaTrackType = {}));
